import { NgModule } from '@angular/core';
import { HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi, HttpClientModule } from '@angular/common/http';
import { BrowserModule } from '@angular/platform-browser';
import { RouterModule } from '@angular/router';
import { JwtModule } from '@auth0/angular-jwt';
import { NgbDateParserFormatter, NgbDateNativeAdapter } from '@ng-bootstrap/ng-bootstrap';
import { NgxMaskModule } from 'ngx-mask';

import { CoreRouting } from './core.routing';
import { SharedModule } from '../shared/shared.module';
import { SystemMessageModule } from './system-message/system-message.module';
import { SystemMessageService } from './system-message/system-message-service';
import { LayoutModule } from './layout/layout.module';
import { HttpClientInterceptor } from './interceptors/http-client-interceptor';
import { SpinnerService } from './layout/spinner/spinner.service';
import { SecurityService } from './security/security.service';
import { NavigationService } from '../shared/navigation/navigation.service';
import { NgbDateNativeParserFormatter } from '../shared/form-elements/components/date-picker/ngb-date-native-parser-formatter';
import { WebAuthnService } from './security/multi-factor-auth/web-authn.service';
import { MultiFactorAuthModalComponent } from './pages/login/multi-factor-auth-modal/multi-factor-auth-modal.component';
import { InactivityTimeoutComponent } from './inactivity-timeout/inactivity-timeout.component';
import { InactivityTimeoutService } from './inactivity-timeout/inactivity-timeout.service';
import { GetPasswordComponent } from './security/get-password/get-password.component';
import { FilterSaveService } from '../shared/table/filter-save.service';
import { PushNotificationModule } from './push-notification/push-notification.module';
import { WebReleaseNotesComponent } from './pages/web-release-notes/web-release-notes.component';
import { MobileReleaseNotesComponent } from './pages/mobile-release-notes/mobile-release-notes.component';
import { CollapsibleTableService } from './collapsible-table/collapsible-table.service';

export function getToken() { return localStorage.getItem("jwt"); }


/***
 * Contains application-wide, single use components and services.
 * Imported once (in the AppModule) when the app starts and never imported anywhere else.
 */
@NgModule({ declarations: [
        ...CoreRouting.declarations,
        MultiFactorAuthModalComponent,
        InactivityTimeoutComponent,
        GetPasswordComponent,
        WebReleaseNotesComponent,
        MobileReleaseNotesComponent,
    ],
    exports: [
        ...CoreRouting.exports,
        SharedModule,
        LayoutModule,
        HttpClientModule,
        RouterModule,
        SystemMessageModule,
        PushNotificationModule,
        BrowserModule,
    ], imports: [...CoreRouting.imports,
        BrowserModule,
        SystemMessageModule,
        PushNotificationModule,
        LayoutModule,
        SharedModule,
        NgxMaskModule.forRoot(),
        JwtModule.forRoot({
			config: {
				tokenGetter: getToken
				, allowedDomains: [window.location.host]
			}
		})
    ], providers: [
        ...CoreRouting.providers,
        SystemMessageService,
        SpinnerService,
        // Security
        SecurityService,
        WebAuthnService,
        InactivityTimeoutService,
        CollapsibleTableService,
        NavigationService,
        FilterSaveService,
        // Bootstrap date providers
        { provide: NgbDateParserFormatter, useClass: NgbDateNativeParserFormatter },
        NgbDateNativeAdapter,
        // Add our HTTP client interceptor
        { provide: HTTP_INTERCEPTORS, useClass: HttpClientInterceptor, multi: true },
        provideHttpClient(withInterceptorsFromDi()),
    ] })
export class CoreModule {}
